import React from 'react';

import { IBringgUuids } from '@rbi-ctg/frontend';
import { IServerOrder } from '@rbi-ctg/menu';
import Map from 'pages/order-confirmation/map';

import DeliveryDetails from '../delivery-details';

import { Container, DeliveryDetailsContainer, MapContainer } from './styled';

interface IDeliveryOrderCard {
  serverOrder: IServerOrder;
  bringgUuids: IBringgUuids;
}

const DeliveryOrderCard = ({ serverOrder, bringgUuids }: IDeliveryOrderCard) => {
  return (
    <Container>
      <MapContainer>
        <Map bringgUuids={bringgUuids} serverOrder={serverOrder} />
      </MapContainer>

      {serverOrder.delivery && (
        <DeliveryDetailsContainer>
          <DeliveryDetails serverOrder={serverOrder} />
        </DeliveryDetailsContainer>
      )}
    </Container>
  );
};

export default DeliveryOrderCard;
